import { WardrobeObject } from '@/Engine/Wardrobe/WardrobeObject';
import { iApp } from '@/Interfaces/app';
import { Window } from '@/Engine/Window';
import { Door } from '@/Engine/Door';
import { IV3D } from '@/Interfaces/v3d';
import { engineConfig } from '@/Constants/3dConfig';
import { $ } from '@/Engine/state';
declare let v3d: IV3D;
export const addBoxHelpers = (objects: Array<WardrobeObject | Window | Door>) => {
    if (!engineConfig.boxHelper) return;
    // app.scene.children.forEach((child)=>{
    //     if (child.type === 'Box3Helper') app.scene.remove(child);
    // });
    objects.forEach((module: WardrobeObject | Window | Door)=> {
        const helper = new v3d.Box3Helper(module.box, new v3d.Color(0xffff00));
        $.app.scene.add(helper);
    });
};

export function removeBoxHelpers() {
    if (!engineConfig.boxHelper) return;
    $.app.scene.children.forEach((child)=>{
        if (child.type === 'Box3Helper') $.app.scene.remove(child);
        if (child.name.includes('temp')) $.app.scene.remove(child);
    });
}
